var _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinktree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 540,
    r: 540,
    fill: "#62d877"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3 0 0 1.3 540 540)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-208.5, -256.12)",
    d: "M 171.274 344.942 L 245.364 344.942 L 245.364 512.238 L 171.274 512.238 L 171.274 344.942 z M 0 173.468 L 126.068 173.468 L 36.446 88.02799999999999 L 86.037 37.04299999999999 L 171.476 124.87199999999999 L 171.476 0 L 245.562 0 L 245.562 124.872 L 331 37.243 L 380.552 88.02799999999999 L 290.97200000000004 173.26799999999997 L 417 173.26799999999997 L 417 243.76999999999998 L 290.252 243.76999999999998 L 380.435 331.399 L 331 381.192 L 208.519 258.11 L 86.037 381.192 L 36.446000000000005 331.601 L 126.66400000000002 243.97 L 0 243.97 L 0 173.46800000000002 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinktree);
export default __webpack_public_path__ + "static/media/linktree.03b6e2c755934a1121f121df1a186bbb.svg";
export { ForwardRef as ReactComponent };